import { render, staticRenderFns } from "./refer-login.vue?vue&type=template&id=67e5edd5&scoped=true&"
import script from "./refer-login.vue?vue&type=script&lang=js&"
export * from "./refer-login.vue?vue&type=script&lang=js&"
import style0 from "./refer-login.vue?vue&type=style&index=0&id=67e5edd5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e5edd5",
  null
  
)

export default component.exports